var Marionette = require('marionette')
var tmplFooter = require('./../templates/Footer.html')
var translations = require('./../../../libs/translationsUtils/translations')

module.exports = Marionette.ItemView.extend({
  template: tmplFooter,
  className: 'survey-footer__items__container',

  ui: {
    prev: '.js-item-prev',
    next: '.js-item-next',
    submit: '.js-survey-submit'
  },

  events: {
    'click @ui.submit': 'onSubmitClick'
  },

  triggers: {
    'click @ui.next': 'show:next:item',
    'click @ui.prev': 'show:prev:item'
  },

  templateHelpers: function () {
    return {
      t: translations.t
    }
  },

  onShowNextItem: function () {
    this.model.nextItem()
  },

  onShowPrevItem: function () {
    this.model.prevItem()
  },

  onSubmitClick: function () {
    if (!this.options.userIsGuest) {
      this.model.submitParticipation()
    }
  },

  initialize: function () {
    this.listenTo(this.model, 'change:current', this.render.bind(this))
  }
})
